import { useMemo } from "react";

import { type ContractModel, ContractTypeDoitOneTimeServiceFee, type EntityModel } from "@doitintl/cmp-models";
import { Stack } from "@mui/material";
import Typography from "@mui/material/Typography";

import { type Entity } from "../../../Context/customer/EntitiesContext";
import { useCustomerContext } from "../../../Context/CustomerContext";
import { NotAvailable } from "../../Assets/Tabs/components/typographics";
import { useContractTypesContext } from "../../ContractsTabs/ContractsTypesContext";
import GeneralSection from "./components/GeneralSection";
import OneTimeServiceFeeDetails from "./OneTimeServiceFeeDetails";
import SubscriptionSection from "./SubscriptionSection";

export type ContractPageSubscriptionProps = {
  contract: ContractModel;
  accountManagerName?: string;
  isSidePanel?: boolean;
};

export const cyIds = {
  text: {
    title: "title",
  },
  sections: {
    general: "general-section",
  },
};

const ContractPageSubscription = ({ contract, accountManagerName, isSidePanel }: ContractPageSubscriptionProps) => {
  const { entities, entitiesLoading } = useCustomerContext();
  const { getContractTypeLabel } = useContractTypesContext();
  const pageTitle = getContractTypeLabel(contract.type);

  const entity = useMemo<Entity | undefined>(
    () => entities.find((ent) => ent.id === contract.entity?.id),
    [contract.entity?.id, entities]
  );

  return (
    <Stack spacing={3}>
      {!isSidePanel && (
        <Typography variant="h1" data-cy={cyIds.text.title}>
          {pageTitle}
        </Typography>
      )}
      <GeneralSection
        entity={entity as EntityModel}
        entitiesLoading={entitiesLoading}
        accountManagerName={accountManagerName || NotAvailable}
        contract={contract}
      />
      {contract.type === ContractTypeDoitOneTimeServiceFee ? (
        <OneTimeServiceFeeDetails contract={contract} />
      ) : (
        <SubscriptionSection contract={contract} />
      )}
    </Stack>
  );
};

export default ContractPageSubscription;
